import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "search", "results" ]

  connect() {
    this.filters = { searched: "" }
  }

  searchChange(event) {
    this.filters.searched = this.searchTarget.value
    this.filters.page = 1
    this.change()
  }

  paginateChange(event) {
    event.preventDefault()
    this.filters.page = event.currentTarget.innerHTML
    this.change()
  }

  change() {
    fetch(this.data.get("url"), {
      method: 'POST',
      body: JSON.stringify( this.filters ),
      credentials: "include",
      dataType: 'script',
      headers: {
        "X-CSRF-Token": getMetaValue("csrf-token"),
        "Content-Type": "application/json"
      },
    })
    .then(response => response.text())
    .then(html => {
      this.resultsTarget.innerHTML = html
    })
  }
}

function getMetaValue(name) {
  const element = document.head.querySelector(`meta[name="${name}"]`)
  return element.getAttribute("content")
}
